import { connect } from 'react-redux';
import RevertButton from './RevertButton';
import { fetchProductsBySection, setAddedProducts, setInputDataToSend } from '../../../../../store/form/actions';
import {
  getAddedProducts,
  getInputDataToSend,
  getTreeStructureSettings,
} from '../../../../../store/form/selectors';

const mapStateToProps = (state) => ({
  inputData: getInputDataToSend(state),
  treeStructure: getTreeStructureSettings(state),
  addedProducts: getAddedProducts(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchProductsBySection: (
    fetchSettings,
  ) => {
    dispatch(fetchProductsBySection(
      fetchSettings,
    ));
  },
  setAddedProducts: (uniqueItem) => {
    dispatch(setAddedProducts(uniqueItem));
  },

  setInputDataToSend: (key, data) => {
    dispatch(setInputDataToSend(key, data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RevertButton);
